import { combineSlices, configureStore } from '@reduxjs/toolkit';
import analyticsReducer from './analyticsSlice';

export const rootReducer = combineSlices({
  [analyticsReducer.reducerPath]: analyticsReducer.reducer
});

const store = configureStore({
  reducer: rootReducer,
  devTools: false
});
export default store;
